export const environment = {
  production: true,
  apiUrl: 'https://api.dev.tcmr.mazdaeur.com',
  auth0ClientId: 'FAT7CpbXjgaWVRaQ9OYH034uPR0kcoAm',
  auth0Domain: 'sso-moa.cappsacc.mazdaeur.com',
  auth0Audience: 'urn:api:mazdaeur.com:tcmr3',
  appUrl: 'https://dev.tcmr.mazdaeur.com',
};
